import { render, staticRenderFns } from "./SignupCta.vue?vue&type=template&id=0dd8ee87"
import script from "./SignupCta.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupCta.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports